// extracted by css-extract-rspack-plugin
export default {"spaceXXLarge":"84px","spaceLarge":"32px","dashboard":"dashboard-v2__dashboard___bEiUU"};